.a3{overflow:hidden;}